import { Box, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import React from "react";
import { customCurrencyFormat } from "../../../utils";

const RoyaltyFeeTable = ({fees = [], total = 0 }) => {
  return (
    <Box overflowX="auto">
      <Table variant="unstyled" textColor="#1A202C">
        <Tbody>

          {fees.map((fee) => (
            <Tr
              key={fee.id}
              fontSize="14px"
              fontWeight={400}
              textColor="#1A202C"
            >
              <Td padding="2px 10px">
                <Text>{fee.name}</Text>
              </Td>
              <Td textAlign="right" padding="2px 30px">
                {customCurrencyFormat(
                  fee.calculated_amount,
                  false,
                  true,
                  false,
                  true
                )}
              </Td>
            </Tr>
          ))}

          <Tr borderTop="1px solid grey" fontSize="14px" fontWeight={800}>
            <Td padding={"2px 10px"}>Total</Td>
            <Td textAlign="right" padding={"2px 30px"}>
              {customCurrencyFormat(total, false, true, true, true)}
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </Box>
  );
};

export default RoyaltyFeeTable;